module.exports = __webpack_public_path__ + "static/media/br.87032851.svg";